export default __webpack_public_path__ + "img/dCysxmvj.48a5a54a.svg";